import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=36f875ed&scoped=true&"
import script from "./HistoryDialog.vue?vue&type=script&lang=js&"
export * from "./HistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDialog.vue?vue&type=style&index=0&id=36f875ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f875ed",
  null
  
)

export default component.exports